enum ListingQueryTypesEnum {
  Personal = 'Personal',
  Active = 'Active',
}

export default ListingQueryTypesEnum;
